import { forwardRef, useContext, useEffect } from "react";
import { chain } from "react-aria";
import { useControlledState } from "@react-stately/utils";

import PhoneInputContext from "../PhoneInputContext";
import { CountrySelect, type CountrySelectProps } from "../CountrySelect";

export type CountryProps = Omit<
  CountrySelectProps,
  "popoverWidth" | "aria-describedby"
> &
  (
    | Required<Pick<CountrySelectProps, "selectedKey">>
    | Required<Pick<CountrySelectProps, "defaultSelectedKey">>
  );

const Country = forwardRef<HTMLButtonElement, CountryProps>((props, ref) => {
  const { countryDescribedBy, groupWidth, setStartSlot } =
    useContext(PhoneInputContext);

  const [selectedKey, setSelectedKey] = useControlledState(
    props.selectedKey,
    props.defaultSelectedKey || null
  );

  const handleSelectionChange = chain(props.onSelectionChange, setSelectedKey);

  useEffect(() => {
    const selectedItem = props.items.find(({ id }) => {
      return id === selectedKey;
    });

    if (selectedItem) {
      setStartSlot(selectedItem.callingCode);
    }
  }, [selectedKey]);

  return (
    <CountrySelect
      aria-label="Country code"
      {...props}
      ref={ref}
      popoverWidth={groupWidth}
      selectedKey={selectedKey}
      onSelectionChange={handleSelectionChange}
      aria-describedby={countryDescribedBy}
    />
  );
});

Country.displayName = "Country";

export default Country;
